import { ElementType } from 'react';

import { IcCheckBold16Icon, IcClock16Icon, IcCloseSmall16Icon, IcQuestion16Icon } from '@gem/icons';

import { ConfirmationType } from 'APP/model/calendar/calendar.types';

type TCalendarParticipantAvatarTheme = 'accepted' | 'declined' | 'maybe' | 'awaiting';

export interface ICalendarParticipantAvatarPresenter {
  confirmationTypeName: TCalendarParticipantAvatarTheme;
  Icon: ElementType;
}

export interface ICalendarParticipantAvatarPresenterParams {
  confirmationType: ConfirmationType;
}

export function useCalendarParticipantAvatarPresenter(
  params: ICalendarParticipantAvatarPresenterParams
): ICalendarParticipantAvatarPresenter {
  const { confirmationType } = params;

  const presenter: ICalendarParticipantAvatarPresenter = {
    get confirmationTypeName(): TCalendarParticipantAvatarTheme {
      switch (confirmationType) {
        case ConfirmationType.ACCEPTED:
          return 'accepted';
        case ConfirmationType.DECLINED:
          return 'declined';
        case ConfirmationType.MAYBE:
          return 'maybe';
        case ConfirmationType.NO_ANSWER:
          return 'awaiting';
        default:
          return 'maybe';
      }
    },

    get Icon(): ElementType {
      switch (confirmationType) {
        case ConfirmationType.ACCEPTED:
          return IcCheckBold16Icon;
        case ConfirmationType.DECLINED:
          return IcCloseSmall16Icon;
        case ConfirmationType.MAYBE:
          return IcQuestion16Icon;
        case ConfirmationType.NO_ANSWER:
          return IcClock16Icon;
        default:
          return IcQuestion16Icon;
      }
    },
  };

  return presenter;
}
